import React from "react";
import "./PrivacyPolicy.css";
import { APP_NAME } from "../constant/constant";
import { useT } from "../i18n";
const PrivacyPolicy = () => {
  const { t } = useT();
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy">
        <h1>{t('Privacy Policy')}</h1>
        <p>
          Privacy Policy for {APP_NAME}
        </p>

        <p>
          Last updated: September 06, 2024
        </p>

        <p>
          This Privacy Policy describes Our policies and procedures on the
          collection, use and disclosure of Your information when You use the
          Service and tells You about Your privacy rights and how the law
          protects You.
        </p>

        <p>
          We use Your Personal data to provide and improve the Service. By using
          the Service, You agree to the collection and use of information in
          accordance with this Privacy Policy. This Privacy Policy has been
          created with the help of the Free Privacy Policy Generator.
        </p>

        <h2>Interpretation and Definitions</h2>
        <h3>Interpretation</h3>
        <p>
          The words of which the initial letter is capitalized have meanings
          defined under the following conditions. The following definitions
          shall have the same meaning regardless of whether they appear in
          singular or in plural.
        </p>

        <h3>Definitions</h3>
        <p>For the purposes of this Privacy Policy:</p>
        <ul>
          <li>
            <strong>Account:</strong> A unique account created for You to access
            our Service or parts of our Service.
          </li>
          <li>
            <strong>Affiliate:</strong> An entity that controls, is controlled
            by or is under common control with a party, where "control" means
            ownership of 50% or more of the shares, equity interest or other
            securities entitled to vote for election of directors or other
            managing authority.
          </li>
          <li>
            <strong>Application:</strong> Refers to {APP_NAME}, the software
            program provided by the Company.
          </li>
          <li>
            <strong>Company:</strong> (referred to as either "the Company",
            "We", "Us" or "Our" in this Agreement) refers to {APP_NAME}.
          </li>
          <li>
            <strong>Country:</strong> Refers to: Rajasthan, India.
          </li>
          <li>
            <strong>Device:</strong> Any device that can access the Service such
            as a computer, a cellphone or a digital tablet.
          </li>
          <li>
            <strong>Personal Data:</strong> Any information that relates to an
            identified or identifiable individual.
          </li>
          <li>
            <strong>Service:</strong> Refers to the Application.
          </li>
          <li>
            <strong>Service Provider:</strong> Any natural or legal person who
            processes the data on behalf of the Company. It refers to
            third-party companies or individuals employed by the Company to
            facilitate the Service, to provide the Service on behalf of the
            Company, to perform services related to the Service or to assist
            the Company in analyzing how the Service is used.
          </li>
          <li>
            <strong>Usage Data:</strong> Data collected automatically, either
            generated by the use of the Service or from the Service
            infrastructure itself (for example, the duration of a page visit).
          </li>
          <li>
            <strong>You:</strong> The individual accessing or using the Service,
            or the company, or other legal entity on behalf of which such
            individual is accessing or using the Service, as applicable.
          </li>
        </ul>

        <h2>Collecting and Using Your Personal Data</h2>
        <h3>Types of Data Collected</h3>
        <h4>Personal Data</h4>
        <p>
          While using Our Service, We may ask You to provide Us with certain
          personally identifiable information that can be used to contact or
          identify You. Personally identifiable information may include, but is
          not limited to:
        </p>
        <ul>
          <li>First name and last name</li>
          <li>Phone number</li>
          <li>Usage Data</li>
        </ul>

        <h4>Usage Data</h4>
        <p>
          Usage Data is collected automatically when using the Service.
        </p>

        <p>
          Usage Data may include information such as Your Device Internet
          Protocol address (e.g. IP address), browser type, browser version,
          the pages of our Service that You visit, the time and date of Your
          visit, the time spent on those pages, unique device identifiers and
          other diagnostic data.
        </p>

        <p>
          When You access the Service by or through a mobile device, We may
          collect certain information automatically, including, but not limited
          to, the type of mobile device You use, Your mobile device unique ID,
          the IP address of Your mobile device, Your mobile operating system,
          the type of mobile Internet browser You use, unique device
          identifiers and other diagnostic data.
        </p>

        <p>
          We may also collect information that Your browser sends whenever You
          visit our Service or when You access the Service by or through a
          mobile device.
        </p>

        <h3>Use of Your Personal Data</h3>
        <p>The Company may use Personal Data for the following purposes:</p>
        <ul>
          <li>
            <strong>To provide and maintain our Service:</strong> Including to
            monitor the usage of our Service.
          </li>
          <li>
            <strong>To manage Your Account:</strong> To manage Your
            registration as a user of the Service. The Personal Data You
            provide can give You access to different functionalities of the
            Service that are available to You as a registered user.
          </li>
          <li>
            <strong>For the performance of a contract:</strong> The
            development, compliance and undertaking of the purchase contract
            for the products, items or services You have purchased or of any
            other contract with Us through the Service.
          </li>
          <li>
            <strong>To contact You:</strong> To contact You by email, telephone
            calls, SMS, or other equivalent forms of electronic communication,
            such as a mobile application's push notifications regarding updates
            or informative communications related to the functionalities,
            products or contracted services, including the security updates,
            when necessary or reasonable for their implementation.
          </li>
          <li>
            <strong>To provide You:</strong> With news, special offers and
            general information about other goods, services and events which we
            offer that are similar to those that you have already purchased or
            enquired about unless You have opted not to receive such
            information.
          </li>
          <li>
            <strong>To manage Your requests:</strong> To attend and manage Your
            requests to Us.
          </li>
          <li>
            <strong>For business transfers:</strong> We may use Your
            information to evaluate or conduct a merger, divestiture,
            restructuring, reorganization, dissolution, or other sale or
            transfer of some or all of Our assets, whether as a going concern
            or as part of bankruptcy, liquidation, or similar proceeding, in
            which Personal Data held by Us about our Service users is among the
            assets transferred.
          </li>
          <li>
            <strong>For other purposes:</strong> We may use Your information
            for other purposes, such as data analysis, identifying usage
            trends, determining the effectiveness of our promotional campaigns
            and to evaluate and improve our Service, products, services,
            marketing and your experience.
          </li>
        </ul>

        <h3>Retention of Your Personal Data</h3>
        <p>
          The Company will retain Your Personal Data only for as long as is
          necessary for the purposes set out in this Privacy Policy. We will
          retain and use Your Personal Data to the extent necessary to comply
          with our legal obligations (for example, if we are required to retain
          your data to comply with applicable laws), resolve disputes, and
          enforce our legal agreements and policies.
        </p>

        <h3>Contact Us</h3>
        <p>
          If you have any questions about this Privacy Policy, You can contact
          us:
        </p>
        <ul>
          <li>By email: shramaraju911@gmail.com</li>
        </ul>
        <br/>
        <br/>
        <br/>
        </div>
        
        </div>);

};

export default PrivacyPolicy;